module.exports = __webpack_public_path__ + "img/ic-selec-arrow-close.c1cbd0b4.svg";